var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPlaneLoader)?_c('div',{staticClass:"loader"},[_c('div',{staticClass:"inner"},[_c('img',{attrs:{"src":require("assets/images/loader/plane.svg"),"alt":"AirBaltic","width":_vm.getDimension,"height":_vm.getDimension}})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }